export const TICKET_STATUSES_LOAD = 'TICKET_STATUSES_LOAD';
export const TICKET_STATUSES_LOAD_SUCCESS = 'TICKET_STATUSES_LOAD_SUCCESS';
export const TICKET_STATUSES_LOAD_ERROR = 'TICKET_STATUSES_LOAD_ERROR';
export const TICKET_STATUSES_ADD = 'TICKET_STATUSES_ADD';
export const TICKET_STATUSES_ADD_SUCCESS = 'TICKET_STATUSES_ADD_SUCCESS';
export const TICKET_STATUSES_ADD_ERROR = 'TICKET_STATUSES_ADD_ERROR';
export const TICKET_STATUSES_UPDATE = 'TICKET_STATUSES_UPDATE';
export const TICKET_STATUSES_UPDATE_SUCCESS = 'TICKET_STATUSES_UPDATE_SUCCESS';
export const TICKET_STATUSES_UPDATE_ERROR = 'TICKET_STATUSES_UPDATE_ERROR';
export const TICKET_STATUSES_DELETE = 'TICKET_STATUSES_DELETE';
export const TICKET_STATUSES_DELETE_SUCCESS = 'TICKET_STATUSES_DELETE_SUCCESS';
export const TICKET_STATUSES_DELETE_ERROR = 'TICKET_STATUSES_DELETE_ERROR';
